mod.modules.define("FeaturedCommentary", "BaseModule", function (fn) {

	fn.prototype.init = function (params) {
		this.base("init", params);

		var $articles = this.el.find(".secondaryArticleContainer");

		for(var i=0;i<$articles.length; ++i){
			var $el = $($articles[i]);
			var Top = $el.position().top;
			var Summary = $el.find(".summary");
			var SummaryTop = 0;
			if(Summary.length > 0 )
			{
				SummaryTop = Summary.position().top;
			}
			var ReadMoreHeight = $el.find(".readMoreLink").height();

			var TopSectionHeight = SummaryTop - Top;
			var TotalHeight = $el.height();
			var MaxContentHeight = TotalHeight - TopSectionHeight - ReadMoreHeight - 10;

			Summary.dotdotdot({
				height : MaxContentHeight,
				tolerance: 0,
				wrap: 'letter'
			});
		}
	};

});